/* Store initialization */
export const SET_WHAT_CONTENT = 'SET_WHAT_CONTENT'
export const SET_WHO_CONTENT = 'SET_WHO_CONTENT'
export const SET_WHERE_CONTENT = 'SET_WHERE_CONTENT'
